'use client';
import { useUser } from '@/app/hooks/useUser';
import { NotificationService } from '@/app/service/notifications';
import { BellIcon } from '@/public/icon';
import { Box, BoxProps, IconButton, SxProps, Theme, Badge } from '@mui/material';
import deepmerge from 'deepmerge';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

interface NotificationsAlert extends BoxProps {
    onClick?: () => void;
    sx?: SxProps;
}

const NotificationsAlert: React.FC<NotificationsAlert> = ({ onClick = () => {}, sx = {} }) => {
    const router = useRouter();
    const { user } = useUser();
    const [unreadCount, setUnreadCount] = useState<number>(0);

    const gotoNotificationsPage = () => {
        router.push('/mychannel/notifications');
    };

    const checkHasNotifications = async () => {
        try {
            const { data } = await NotificationService.checkHasNotifications();
            // Assuming the API returns unread count, adjust if needed
            setUnreadCount(data.haveNotification ? 1 : 0);
        } catch (error) {}
    };

    useEffect(() => {
        if (user?.id) {
            checkHasNotifications();

            const handleVisibilityChange = () => {
                if (document.visibilityState === 'visible') {
                    checkHasNotifications();
                }
            };

            document.addEventListener('visibilitychange', handleVisibilityChange);
            return () => {
                document.removeEventListener('visibilitychange', handleVisibilityChange);
            };
        }
    }, [user?.id]);

    return (
        <Box
            sx={deepmerge<SxProps<Theme>>(
                {
                    cursor: 'pointer',
                    position: 'relative',
                },
                sx
            )}
        >
            <IconButton
                sx={{ position: 'relative' }}
                onClick={() => gotoNotificationsPage()}
            >
                <Badge
                    badgeContent={
                        unreadCount > 0 ? (
                            <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="3" cy="3" r="3" fill="#FF2164" />
                            </svg>
                        ) : null
                    }
                    sx={{
                        '& .MuiBadge-badge': {
                            right: '6px',
                            top: '6px',
                            minWidth: '6px',
                            height: '6px',
                            padding: 0,
                            borderRadius: '50%',
                        }
                    }}
                >
                    <BellIcon />
                </Badge>
            </IconButton>
        </Box>
    );
};

export default NotificationsAlert;
